"use client"

import { useEffect, useState } from "react"

/**
 * Shared by the mobile bottom bar and the floating desktop button, so the two
 * cannot drift apart on when a persistent CTA is allowed to show.
 *
 * Two rules. It stays out of the way until the reader has actually started
 * reading, and it disappears over the footer, because the footer holds the
 * address and the phone number and covering those is worse than not having a
 * button at all.
 */
export function useCtaVisibility(showAfter = 320) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    let frame = 0

    const update = () => {
      const scrolledPastHero = window.scrollY > showAfter
      const footer = document.querySelector("footer")
      const footerTop = footer?.getBoundingClientRect().top ?? Number.POSITIVE_INFINITY
      setVisible(scrolledPastHero && footerTop > window.innerHeight)
    }

    const onScroll = () => {
      if (frame) {
        window.cancelAnimationFrame(frame)
      }
      frame = window.requestAnimationFrame(update)
    }

    update()
    window.addEventListener("scroll", onScroll, { passive: true })
    window.addEventListener("resize", onScroll)

    return () => {
      if (frame) {
        window.cancelAnimationFrame(frame)
      }
      window.removeEventListener("scroll", onScroll)
      window.removeEventListener("resize", onScroll)
    }
  }, [showAfter])

  return visible
}
